<page-title [title]="title"></page-title>
<p>Veja abaixo os exames/procedimentos cadastrados pela sua instituição:</p>

<mat-tab-group>
  <!-- Tab de ativos -->
  <mat-tab label="Ativos">
    <ng-container *ngIf="procedures.length > 0; else noActive">
      <mat-card *ngFor="let procedure of procedureActive" (click)="openProcedureDatail(procedure)">
        {{ procedure.name }}
      </mat-card>
    </ng-container>
    <ng-template #noActive>
      <div class="empty-message">
        Nenhum exame/procedimento ativo encontrado.
      </div>
    </ng-template>

    <div class="actions">
      <button mat-flat-button color="primary" (click)="openProcedureForm()">
        Cadastrar
      </button>
    </div>

  </mat-tab>

  <!-- Tab de inativos -->
  <mat-tab label="Inativos">
    <ng-container *ngIf="procedures.length > 0; else noInactive">
      <mat-card *ngFor="let procedure of procedureInactive" (click)="openProcedureDatail(procedure)">
        {{ procedure.name }}
      </mat-card>
    </ng-container>
    <ng-template #noInactive>
      <div class="empty-message">
        Nenhum exame/procedimento inativo encontrado.
      </div>
    </ng-template>
  </mat-tab>
</mat-tab-group>